import { z } from 'zod';

export const scrollEffectV0Schema = z.object({
    version: z.literal(0),
    /** `isScrollEffect` — with the effect off the value is not read at all. */
    isEnabled: z.boolean(),
    /** An `EScrollEffect` literal on the host: `parallax` or `fixed`. */
    value: z.string(),
});
